import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChartComponentBase, ChartType } from '../chart.types';

@Component({
  selector: 'chart-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartLineComponent extends ChartComponentBase {
  prepareChart(): void {
    this.chartOptions = {
      chart: {
        type: ChartType.Line,
        height: this.height ? this.height : this.fillMode ? '96%' : 'auto',
        width: '96%',
        zoom: {
          enabled: false,
        },
        events: {
          dataPointSelection: (event, chart, options) => {
            this.dataPointSelection.emit(options);
          },
        },
        animations: {
          enabled: false,
        },
      },
      colors: this.defaultColors,
      fill: {
        colors: ['#CED9FB', '#AECDFD'],
        opacity: 0.5,
        type: 'solid',
      },
      series: this.isTimeSeries
        ? this.chartDef.series
        : [
            {
              name: this.chartDef.summary_value,
              data: Object.keys(this.chartDef.data).map((key) => this.chartDef.data[key]),
            },
          ],
      stroke: {
        curve: 'straight',
        width: 2,
      },
      markers: {
        size: 0,
      },
      tooltip: {
        theme: 'dark',
        x: {
          format: 'MMM dd, yyyy',
        },
        y: {
          formatter: (value) => value?.toString(),
        },
      },
      xaxis: {
        categories: this.isTimeSeries ? this.chartDef.rankedCategories : Object.keys(this.chartDef.data),
      },
    };
  }
}
